export default __webpack_public_path__ + "static/media/iconCaretDown.73dfc872.svg";